import * as yup from "yup";

export function buildValidationSchema() {
  return yup.object().shape({
    name: yup.string().label("Nombre de la cuenta").required("Campo requerido"),
  });
}
